import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({ selector: '[fill-empty]' })
export class FillEmptyDirective {
    @Input('fill-empty') public text!: string;

    public constructor(
        private readonly elementRef: ElementRef
    ) { }

    @HostListener('insBlur', ['$event'])
    protected onBlur(event: Event): void {
        if (!(event.target as HTMLInputElement).value) {
            this.elementRef.nativeElement.value = this.text;
            event.preventDefault();
        }
    }
}
